import React, { ReactElement, useState } from "react";
import SelectForm from "../../shared/forms/SelectForm";
import HiddenForm from "../../shared/forms/HiddenForm";
import { QuestionnaireEditType } from "../../../models/Questionnaire";
import { CommunityCapitalQuestionResponse } from "../../../models/CommunityCapitalQuestion";

interface Props {
  questionnaire: QuestionnaireEditType;
  communityCapitalQuestion: CommunityCapitalQuestionResponse;
  questionIndex: number;
  showForm: boolean;
}

export default function WellBeingSelectForm(props: Props): ReactElement {
  const { showForm, questionnaire, communityCapitalQuestion, questionIndex } =
    props;
  const communityCapitalAnswer = questionnaire.community_capital_answers.find(
    (a) => a.community_capital_question_id === communityCapitalQuestion.id
  );
  const [value, setValue] = useState(
    String(communityCapitalAnswer?.point || "")
  );
  return (
    <>
      {!showForm && value && (
        <>
          <HiddenForm
            scope="questionnaire"
            relatedModelName="community_capital_answers"
            index={questionIndex}
            columnName="community_capital_question_id"
            value={communityCapitalQuestion.id}
          />
          <HiddenForm
            scope="questionnaire"
            relatedModelName="community_capital_answers"
            index={questionIndex}
            columnName="point"
            value={value}
          />
        </>
      )}
      {showForm && (
        <>
          <HiddenForm
            scope="questionnaire"
            relatedModelName="community_capital_answers"
            index={questionIndex}
            columnName="community_capital_question_id"
            value={communityCapitalQuestion.id}
          />
          <SelectForm
            model={questionnaire}
            scope="questionnaire"
            relatedModelName="community_capital_answers"
            index={questionIndex}
            columnName="point"
            option={{ include_blank: "-- 選択してください --" }}
            options={[
              { key: "10", value: "10点" },
              { key: "9", value: "9点" },
              { key: "8", value: "8点" },
              { key: "7", value: "7点" },
              { key: "6", value: "6点" },
              { key: "5", value: "5点" },
              { key: "4", value: "4点" },
              { key: "3", value: "3点" },
              { key: "2", value: "2点" },
              { key: "1", value: "1点" },
              { key: "0", value: "0点" },
            ]}
            hideLabel
            defaultKey=""
            selectedKey={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </>
      )}
    </>
  );
}
